import * as Rox from "rox-browser";

export const tax_validation = {
    tax_validation_2_2_6_0: new Rox.Flag(),
    tax_validation_2_2_7_0: new Rox.Flag()
};
